// import axios from 'axios';
import HttpClient from './HttpClient';
// import { Encrypt } from './aes';
import aes from './aes';

const api = window.API;

const http = HttpClient.create(
    {
        baseURL: api,
    },
    [[aes]],
);
export default http;
